<template>
    <div v-if="summaryData && summaryData.capacity > 0">
        <div class="chart-container mb-3">
            <div class="bar">
                <div class="bar-section filled" :style="{ height: summaryData.percentage + '%' }"></div>
            </div>

            <div class="level-line max" style="bottom: 100%">
                <span class="line-label">Max</span>
                <span class="line-value">{{ summaryData.capacityStr }} lt</span>
            </div>
            <div class="level-line" style="bottom: 50%">
                <span class="line-label">Ort</span>
                <span class="line-value">{{ summaryData.avgStockStr }} lt</span>
            </div>
            <div class="level-line" :style="{ bottom: summaryData.minStockPercentage + '%' }">
                <span class="line-label">Min</span>
                <span class="line-value">{{ summaryData.minStockStr }} lt</span>
            </div>
            <div class="level-line critical" :style="{ bottom: summaryData.criticalStockPercentage + '%' }">
                <span class="line-label">Kritik</span>
                <span class="line-value">{{ summaryData.criticalStockStr }} lt</span>
            </div>
        </div>

        <table class="table table-sm table-bordered mt-2">
            <thead>
                <tr>
                    <th>Açıklama</th>
                    <th class="text-nowrap">Miktar [lt]</th>
                    <th class="text-nowrap">Oran [%]</th>
                    <th class="text-nowrap">Renk Kodu</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Boş Kapasite</td>
                    <td class="text-right">{{ summaryData.emptySpaceStr }}</td>
                    <td class="text-right font-weight-bolder">{{ summaryData.emptySpacePercentageStr }}</td>
                    <td class="text-center">
                        <span class="color-box empty"></span>
                    </td>
                </tr>
                <tr>
                    <td>Yakıt Miktarı</td>
                    <td class="text-right">{{ summaryData.quantityStr }}</td>
                    <td class="text-right font-weight-bolder">{{ summaryData.percentageStr }}</td>
                    <td class="text-center">
                        <span class="color-box filled"></span>
                    </td>
                </tr>
                <tr>
                    <td>Depo Kapasitesi</td>
                    <td class="text-right">{{ summaryData.capacityStr }}</td>
                    <td class="text-right font-weight-bolder">100,00</td>
                    <td class="text-center">
                        <span class="color-box capacity"></span>
                    </td>
                </tr>
                <tr>
                    <td>Minimum Stok</td>
                    <td class="text-right">{{ summaryData.minStockStr }}</td>
                    <td class="text-right font-weight-bolder">{{ summaryData.minStockPercentageStr }}</td>
                    <td class="text-center">
                        <span class="color-box min"></span>
                    </td>
                </tr>
                <tr>
                    <td>Kritik Stok</td>
                    <td class="text-right">{{ summaryData.criticalStockStr }}</td>
                    <td class="text-right font-weight-bolder">{{ summaryData.criticalStockPercentageStr }}</td>
                    <td class="text-center">
                        <span class="color-box critical"></span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div v-else class="text-center text-muted">
        <p>Görüntülenecek veri yok.</p>
    </div>
</template>

<script>
export default {
    name: "FuelStorageBarChart",
    props: {
        summaryData: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.chart-container {
    position: relative;
    height: 250px;
    width: 40%;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
}

.bar {
    width: 100%;
    height: 100%;
    border: 2px solid #000000;
    display: flex;
    flex-direction: column-reverse;
    overflow: hidden;
    border-radius: 5px;
    background: linear-gradient(to top, rgba(255, 0, 0, 0.849), #f87777e7);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.bar-section.filled {
    width: 100%;
    transition: height 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    background: linear-gradient(to top, #29b100, rgb(124, 219, 160));
}

.level-line {
    position: absolute;
    left: -10px;
    right: -10px;
    border-top: 2px dashed #1d53b1;
}

.level-line.critical {
    border-top-color: #700404;
}

.level-line.max {
    border-top: 2px solid #4c80da;
}

.line-label {
    position: absolute;
    left: -40px;
    top: -10px;
    font-size: 0.8rem;
    font-weight: bold;
    color: #4b5563;
    width: 35px;
    text-align: right;
}

.line-value {
    position: absolute;
    right: -85px;
    top: -10px;
    font-size: 0.8rem;
    width: 80px;
    text-align: right;
    color: #4b5563;
    font-weight: 500;
}

.table th,
.table td {
    padding: 0.4rem;
    font-size: 0.85rem;
}
.color-box {
    display: inline-block;
    width: 40px;
    height: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
}
.color-box.empty {
    background: linear-gradient(to top, rgb(255, 0, 0), #f87777);
}

.color-box.filled {
    background: linear-gradient(to top, #29b100, rgb(124, 219, 160));
}

.color-box.capacity {
    background-color: #000000;
}

.color-box.min {
    background-color: #1d53b1;
}

.color-box.critical {
    background-color: #700404;
}
</style>
